export enum SearchStatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
  CLOSED = "closed",
}